// const host = 'http://192.168.1.68:9001'
// const host = 'http://172.19.144.117:9001'
// const host = 'https://staging.tonicww.in/flexxd-node'
// const host ='http://localhost:9001'
const host = 'https://uat-apl.flexxd.com'
// const host = 'https://apl.flexxd.com'
 //const host = 'http://127.0.0.1:9002'
// const host = 'https://gym-project-backend.onrender.com'


const config = {
  // api_urls :  'https://gym-project-backend.onrender.com/api'
  api_urls: host+"/api",
  host:host ,
  jwtKey:"true", // true for encrypted payload, false for normal payload
};
export default config;

  
